module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "c2",
    attrs: {
      "id": "calibre_pb_1"
    }
  }, [_c('br', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c1"
  }, [_c('img', {
    staticClass: "calibre3",
    attrs: {
      "alt": "tmp_10b66645e68cd802cc2e2d6047672dad_2rfwv1_html_1e71cf4d.jpg",
      "id": "Picture_2",
      "src": "tmp_10b66645e68cd802cc2e2d6047672dad_2rfwv1_html_1e71cf4d.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-431294ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tmp_10b66645e68cd802cc2e2d6047672dad_2rfwv1.ch.fixed.fc.tidied.stylehacked.xfixed_split_002.vue
// module id = 66
// module chunks = 0